import { Grid, Switch } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { Project } from '../../../../domain/project/Project';
import { useUpdateProject } from '../../../../hooks/project/useUpdateProject';
import ProjectCustomersMapper from '../../../../mappers/project/ProjectCustomersMapper';
import { Accordion } from '../../../../react-components/Accordion';
import InputText from '../../../../react-components/InputText';
import Text from '../../../../react-components/Text';

interface CustomersAdditionalInfoProps {
  project: Project;
}

export const CustomersAdditionalInfo = ({ project }: CustomersAdditionalInfoProps) => {
  const { run: editProject } = useUpdateProject({ project });
  const [additionalInfo, setAdditionalInfo] = useState<string>(``);

  useEffect(() => {
    const additionalInfoField = project.customers.fields.find((field) => field.id === `additional_info`);
    setAdditionalInfo(additionalInfoField?.additional_info ?? ``);
  }, [project.customers.fields]);

  const isEnabled = (): boolean => {
    return Boolean(project.customers.fields.find((field) => field.id === `additional_info`));
  };

  const getValue = () => {
    const fieldFound = project.customers.fields.find((field) => field.id === `additional_info`);
    return fieldFound?.additional_info ?? ``;
  };

  return (
    <div
      style={{
        border: `1px solid #E0E0E0`,
        borderRadius: `2px`,
      }}
    >
      <Accordion
        id="customers_app_pin"
        expanded
        headerStyles={{
          position: `relative`,
          paddingTop: `16px`,
        }}
        headerContent={
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            style={{ marginTop: `-8px` }}
          >
            <Text
              style={{ cursor: `pointer` }}
              variant="body-large"
              isBold
              intlId="customers.app.options.additional_info"
            />

            <Switch
              checked={isEnabled()}
              value={isEnabled()}
              onClick={(event) => event.stopPropagation()}
              onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                const projectCustomers = ProjectCustomersMapper.toDTO(project.customers);

                if (!checked) {
                  projectCustomers.fields = projectCustomers.fields.filter((field) => field.id !== `additional_info`);
                } else {
                  projectCustomers.fields.push({
                    id: `additional_info`,
                    type: `string`,
                  });
                }

                editProject({
                  customers: ProjectCustomersMapper.toDomain(projectCustomers),
                });
              }}
              color="primary"
            />
          </Grid>
        }
        contentStyle={{
          padding: `16px`,
          borderTop: `1px solid #E0E0E0`,
        }}
      >
        <Text variant="label" intlId="customers.app.options.additional_info.info" />

        <VSpacer small />

        {isEnabled() ? (
          <InputText
            multiline
            rowsMin={4}
            rowsMax={4}
            placeholderIntlId="customers.app.options.additional_info.placeholder"
            fieldValue={getValue()}
            onChange={(value) => {
              setAdditionalInfo(value);
            }}
            onBlur={(e: any) => {
              if (isEnabled()) {
                const projectCustomers = ProjectCustomersMapper.toDTO(project.customers);
                const additionalInfoField = projectCustomers.fields.find((field) => field.id === `additional_info`);

                if (additionalInfoField?.additional_info === additionalInfo) return;

                projectCustomers.fields = projectCustomers.fields.map((field) => {
                  if (field.id !== `additional_info`) return field;

                  return {
                    ...field,
                    additional_info: additionalInfo,
                  };
                });

                editProject({
                  customers: ProjectCustomersMapper.toDomain(projectCustomers),
                });
              }
            }}
          />
        ) : null}
      </Accordion>
    </div>
  );
};
